module.exports = __webpack_public_path__ + "img/tema-1-4.bddde0da.svg";